export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'Settings',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.open-platform': 'Open Platform',
  'menu.open-platform.internal-applications': 'Internal Apps',
  'menu.open-platform.self-built-applications': 'Self-built Apps',
  'menu.open-platform.personal-applications': 'Personal Apps',
  'menu.open-platform.saas-group': 'Platform Integrations',
  'menu.open-platform.saas-applications': 'SaaS Apps',
  'menu.open-platform.authorized-saas-applications': 'Authorized SaaS Apps',
  'menu.open-platform.saas-group.open-platform.saas-applications': 'SaaS Apps',
  'menu.open-platform.saas-group.open-platform.authorized-saas-applications':
    'Authorized SaaS Apps',
  'menu.open-platform.saas-group.saas-applications': 'SaaS Apps',
  'menu.open-platform.saas-group.authorized-saas-applications':
    'Authorized SaaS Apps',
  'menu.open-platform.saas-docs': 'Integration Guide',
  'menu.open-platform.saas-group.open-platform.saas-docs': 'Integration Guide',
  'menu.open-platform.saas-group.saas-docs': 'Integration Guide',
  'menu.open-platform.saas-user-authorizations': 'Platform User Access',
  'menu.open-platform.saas-group.open-platform.saas-user-authorizations':
    'Platform User Access',
  'menu.open-platform.saas-group.saas-user-authorizations':
    'Platform User Access',
  'menu.open-platform.services': 'Open Capabilities',
  'menu.open-platform.skills': 'Skill Market',
  'menu.open-platform.docs': 'Developer docs',
  'menu.open-platform.workbench': 'Open Platform Workbench',
  'menu.open-platform.call-logs': 'API Call Logs',
  'menu.open-platform.member-list-test': 'Member List Test',

  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
